import type { FetchNotificationSettingsResponse, UpdateNotificationSettingsResponse } from '../types/personPreferenceNotificationSettings';
import { wrapFetch } from '../libs/fetch';

export const fetchNotificationSettings = async (personId: number | string) => {
  return await wrapFetch<FetchNotificationSettingsResponse>(`/api/v1/notification_settings/${personId}`);
};

export const updateNotificationSettings = async (personId: number, notification_setting_id: number, enabled: boolean, csrfToken: string) => {
  return await wrapFetch<UpdateNotificationSettingsResponse>(`/api/v1/notification_settings/${personId}`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': csrfToken,
    },
    // JSON.stringifyをした状態のbodyを引数で渡した方が良いよ〜byキドちゃん
    body: JSON.stringify({ notification_setting_id: notification_setting_id, enabled: enabled }),
    credentials: 'same-origin',
  });
};
